import gql from 'graphql-tag';

// The impersonation response has no `refreshToken` field at all (access-token-only,
// non-renewable — see design D4). `OAuthImpersonateTokens` is the GraphQL type declared in
// `backend/src/@api/o-auth/flows/graphql/flows.graphql`.
export const oAuthCreateImpersonateToken = gql`
  mutation oAuthCreateImpersonateToken($payload: OAuthCreateImpersonateTokenInput!) {
    oAuthCreateImpersonateToken(payload: $payload) {
      accessToken
      tokenType
      expiresIn
    }
  }
`;
